export default {
methods: {
    notEmptyObject(someObject){
      if(someObject){
        console.log('notEmptyObject', someObject, Object.keys(someObject).length);
        return Object.keys(someObject).length;
      }
      return 0;
    },
    isObjectEmpty(someObject){
      return !(Object.keys(someObject).length);
    },
    errorHandler(e) {
      console.log('errorHandler', e);
      //var statusCode = e.response !== null ? e.response.status : e;
      console.log('errorHandler.response', e.response);
      let mensaje = "Error ";
      if(e.response){
          if(e.response.data){
            if(e.response.data.status){
              console.log('errorHandler.response.data', e.response.data);
              mensaje = mensaje + `${e.response.status}.` + '\n' + `${e.response.data.status.mensaje}`;
              if(e.response.data.status.listaMensaje.length > 0){
                e.response.data.status.listaMensaje.forEach(element => {
                  mensaje = mensaje +  '\n' + `${element}`
                });
              }
            }
            if(e.response.data.error_description){
              console.log('errorHandler.response.data.error_description', e.response.data.error_description);
              mensaje = mensaje + `${e.response.data.error_description}`;
            }
          }
      }else{
          mensaje = mensaje + " no identificado";
      }

      this.showError(mensaje);
    },
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errorhandler.js